// Rotas públicas (sem login). Fonte ÚNICA consumida pelo VersionChecker, pelo Amplifique
// e pelo guard de re-autenticação (reauthStore) — nada de modal de update, survey NPS ou
// ReauthModal em fluxo que funciona sem sessão.
//
// Inventário completo contra routes/index.js (fix pós-review, MARINERS-2011): entra aqui
// toda rota SEM PrivateRoute em que (a) o usuário anônimo tem fluxo legítimo, ou (b) a
// rota é fronteira de sessão e gerencia a própria saída (/refresh, /logout). Ficam FORA
// de propósito: '/' e '/permission-error' (só fazem sentido com sessão — a ReauthModal
// lá é comportamento correto) e '/monitoria-de-agendamento-cliente' (parece privada sem
// guard — problema à parte, não é fluxo anônimo).
export const PUBLIC_ROUTE_PREFIXES = [
  '/qr',
  '/chamado',
  '/chamado-woba',
  '/login',
  '/logout',
  '/login-sso',
  '/conta/recuperar',
  '/conta/redefinir-senha',
  '/conection-error',
  '/clientes',
  '/refresh',
];

/**
 * true se o pathname é uma rota pública. Match por segmento: igual ao prefixo
 * ('/qr') ou sob ele ('/qr/ABC') — mas NÃO um prefixo textual acidental ('/qrcode').
 */
export const isPublicRoute = (pathname: string): boolean =>
  PUBLIC_ROUTE_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
